import { Box, CircularProgress } from "@mui/material";

const LoadingSpinner = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      minHeight: 100,
    }}
  >
    <CircularProgress />
  </Box>
);

export default LoadingSpinner;
